<template>
  <div>
    <p class="oficina-slide-text">{{ step.content }}</p>
    <ul class="oficina-list">
      <li
        v-for="(item, idx) in step.items"
        :key="idx"
        class="oficina-list-item"
      >
        <span class="oficina-list-bullet"></span>
        {{ item }}
      </li>
    </ul>
    <div v-if="step.tip" class="oficina-slide-tip">
      <i class="icofont-info-circle"></i>
      {{ step.tip }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.oficina-slide-text {
  font-size: 16px;
  line-height: 1.6;
  color: #1e293b;
  margin-bottom: 24px;
}

.oficina-list {
  list-style: none;
  padding: 0;
  margin: 24px 0;
}

.oficina-list-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  font-size: 15px;
  line-height: 1.6;
  color: #475569;
}

.oficina-list-bullet {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0FAFD7;
  margin-top: 8px;
  flex-shrink: 0;
}

.oficina-slide-tip {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-top: 24px;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
</style>
